import { useRecoilState } from 'recoil';
import homeState from '../../atoms/home';
import messagesState from '../../atoms/messages';
import participantsState from '../../atoms/participants';
import './HomeHeader.scoped.scss';
import emitCleanRoom from '../../connector/emits/cleanRoom';
import myInfoState from '../../atoms/myinfo';

function HomeHeader() {
  const [myInfo] = useRecoilState(myInfoState);
  const [home, setHome] = useRecoilState(homeState);
  const [messages, setMessages] = useRecoilState(messagesState);

  const [participants] = useRecoilState(participantsState);

  return (
    <div>
      <div className="home-header">
        <span className="home-header__icon-chat" aria-hidden="true">💬</span>
        <span className="home-header__participants">할매티비채팅방</span>
        <span className="home-header__count">
          <i className="home-header__count-dot" aria-hidden="true"></i>
          {Math.max(participants.users.length, 1) + 100}명
        </span>
      </div>

    </div>
  );
}

export default HomeHeader;